export default {
  promo: {
    metrics: {
      description_1: 'Eficiența recomandărilor',
      description_2: 'Viteza arhitecturii',
      description_3: 'Adâncimea vizualizării'
    }
  }
}
